import { communityCRUDUrl } from "../constants/apis";
import axios from "axios";
import { getUserToken } from "../helpers/local_storage_helpers";

export const getCommunity = async (query) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(communityCRUDUrl + `${query || ""}`, config);

    return response;
};

export const postCommunity = async (data) => {
    const config = {
        headers: {
            // "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };
    const response = await axios.post(communityCRUDUrl, data, config);
    return response;
};

export const patchCommunity = async ({ data, id }) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };
    const response = await axios.patch(communityCRUDUrl + id + "/", data, config);
    return response;
};

export const deleteCommnityApiCall = async (id) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.delete(communityCRUDUrl + id + "/", config);

    return response;
};
